
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Link from 'next/link';
import { getAllPosts } from '@utils/getPosts';
import { NextSeo } from 'next-seo';
interface IPost {
    posts: {
        slug: string;
        title: string;
        content: string;
        dateGmt: string;
    };
}
const News = ({ posts }: IPost) => {
    const { lang } = useTranslation('common');
    return (<>
      <NextSeo languageAlternates={[
            { hrefLang: 'x-default', href: 'https://knsokna.pl/news' },
            { hrefLang: 'en', href: 'https://knswindows.com/news' },
            { hrefLang: 'pl', href: 'https://knsokna.pl/news' },
            { hrefLang: 'de', href: 'https://knsfenster.de/news' },
            { hrefLang: 'cs', href: 'https://kns-okna.eu/news' },
            { hrefLang: 'it', href: 'https://knsfinestre.it/news' },
            { hrefLang: 'fr', href: 'https://knsfenetres.fr/news' },
            { hrefLang: 'hu', href: 'https://knsokna.eu/news' },
        ]}/>
      <div className="flex flex-wrap justify-center max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-8 lg:px-8">
        {Array.isArray(posts)
            ? posts.map((post) => {
                const publishedDate = new Date(post.date).toLocaleString('pl-PL');
                const descriptionAll = post.content.replace(/(&nbsp;|&#8211;|(<([^>]+)>))/gi, '');
                const description = descriptionAll
                    .split(/\s+/)
                    .slice(0, 20)
                    .join(' ');
                return (<div key={post.databaseId} className="max-w-sm min-h-full bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 m-2">
                  <Image src={post.featuredImage?.node.sourceUrl} alt="about" width="954" height="500" className="rounded-t-lg"/>
                  <time className="text-white text-sm pl-5">
                    {publishedDate}
                  </time>
                  <div className="p-5">
                    <Link href={`news/${post.slug}`}>
                      <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        {post.title}
                      </h5>
                    </Link>
                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                      {description} ...
                    </p>
                    <a href={`news/${post.slug}`} className="inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                      Czytaj więcej
                      <svg aria-hidden="true" className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
                      </svg>
                    </a>
                  </div>
                </div>);
            })
            : null}
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || 'PL';
    const language = locale === 'cz' ? 'CS' : locale.toUpperCase();
    const { allPosts } = await getAllPosts(language, 999);
    const posts = allPosts.posts.nodes;
    return {
        props: {
            posts,
        },
    };
};
export default News;

    async function __Next_Translate__getStaticProps__196386c4fbb__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/news/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196386c4fbb__ as getStaticProps }
  